import { APPROVER_COMMENT_FIELD } from '../constants/vmsApproverAttachments';

export function appendAnnexureApproverExtras(
  fd: FormData,
  options?: { approverComment?: string; approverAttachments?: File[] }
): void {
  const note = options?.approverComment?.trim() ?? '';
  if (note) fd.append(APPROVER_COMMENT_FIELD, note);
  for (const f of options?.approverAttachments ?? []) {
    fd.append('approver_attachments', f);
  }
}
